import axios from "./axios";

const action = {
    async CheckConnetion() {
        return await axios().get(
            "/health"
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async GetSlots() {
        return await axios().get("/Card/GetSlots"
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async GetCertificate(model) {
        return await axios().post("/Card/GetCertificate", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async SerialSign(model) {
        return await axios().post("/Card/SerialSign", model
        ).then(r => {
            return r;
        }).catch(e => {
            return e;
        });
    },
    async GetNonModules(CompanyID) {
        return await axios().get("/Module/" + CompanyID)
            .then(re => {
                return re.data;
            });
    }
}

export default action
